export default "__VITE_ASSET__4Q4nFvky__"